var m = require('mithril');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var ToggleSwitch = require('../components/toggleSwitch');
var L = require('leaflet');

var ModalForm = Object.assign(Object.create(Model), require('../../../../models/locations/Level'));

ModalForm.fields = {
  svg:{
    type: 'textarea',
    default: null,
  },
  createMissing: {
    type: 'boolean',
    default: false,
  },
};

ModalForm.url = 'level/buildroomsfromsvg';
ModalForm.mode = 'rooms';

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

function createTempSvgElement(svgString) {
  const parser = new DOMParser();
  const svgDocument = parser.parseFromString(svgString, "image/svg+xml");
  const svgElement = svgDocument.documentElement;
  if (!svgElement || svgElement.nodeName === 'parsererror' || svgDocument.getElementsByTagName('parsererror').length) {
    return null;
  }
  if (svgElement.nodeName.toLowerCase() !== 'svg') {
    return null;
  }
  // Temporarily append to the DOM
  const tempContainer = document.createElement("div");
  tempContainer.style.position = "absolute";
  tempContainer.style.left = "-9999px";
  tempContainer.appendChild(svgElement);
  document.body.appendChild(tempContainer);
  return svgElement;
}

function redraw() {
  if (typeof window !== 'undefined' && typeof m.redraw === 'function') {
    try {
      m.redraw();
    } catch (error) {}
  }
}

function showValidationError(message) {
  ModalForm.errors = [message];
  redraw();
  return false;
}

ModalForm.editDialogue = function (record, options) {
  let parentRecord = record.path[record.path.length - 2];
  const isEquipment = options && options.equipment;
  if (isEquipment) {
    ModalForm.url = 'level/buildequipmentfromsvg';
    ModalForm.mode = 'equipment';
  } else {
    ModalForm.url = 'level/buildroomsfromsvg';
    ModalForm.mode = 'rooms';
  }

  Model.initForm.call(ModalForm, record);
  ModalForm.record = record ? record : undefined;
  ModalForm.form.svg("");
  ModalForm.form.createMissing(false);

  var submit = function () {
    ModalForm.errors = [];
    const svgValue = (ModalForm.form.svg() || '').trim();
    if (!svgValue) {
      return showValidationError('Enter SVG before saving.');
    }

    const svgElement = createTempSvgElement(svgValue);
    if (!svgElement) {
      return showValidationError('Enter valid SVG before saving.');
    }

    const parentSvgElement = createTempSvgElement(parentRecord.svg || '');

    // Get the MetaInfo from the parent SVG
    const parentMetaInfo = parentSvgElement ? parentSvgElement.querySelector("MetaInfo") : null;

    // Clear existing MetaInfo if it exists
    const existingMetaInfo = svgElement.querySelector("MetaInfo");
    if (existingMetaInfo) {
        existingMetaInfo.remove();
    }

    // Clone the parent's MetaInfo and append it to the current SVG
    if (parentMetaInfo) {
        const clonedMetaInfo = parentMetaInfo.cloneNode(true);
        svgElement.appendChild(clonedMetaInfo);
    }

    // Serialize the SVG element back to a string
    let serializer = new XMLSerializer();
    let updatedSVGString = serializer.serializeToString(svgElement);

    // Update the form with the modified SVG
    ModalForm.form.svg(updatedSVGString);

    // Save the form and close the modal
    return ModalForm.save()
    .then(response => {
        key.unbind('enter');
        options && options.submitCallback ? options.submitCallback() : '';
        modal.vm.close();
        m.redraw();
    });
};

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(isEquipment ? 'Update Equipment with Map SVG' : 'Update Rooms with Map SVG')
  modal.vm.body = ModalForm.view,
  modal.vm.buttons([{
    label: "Save",
    class: "btn-good",
    func: submit
  }]);
  var modelOptions={
    extrawidth:true
  }
  modal.vm.open(modelOptions);
}

ModalForm.counter = 0;

ModalForm.view = function () {
  return m('form', {role:'form'}, [
    ModalForm.errorView(),
    m('label', {for:'comment'}, 'Map SVG:'),
    m('textarea', {
      resize: 'none',
      rows:'5',
      cols:'40', 
      'box-sizing': 'border-box',
      placeholder:"Add Map SVG data here...",
      oninput: ev => ModalForm.form.svg(ev.target.value),
      value: ModalForm.form.svg()
    }),
    (function () {
      const checked = !!ModalForm.form.createMissing();
      const label = ModalForm.mode === 'equipment' ? 'Create missing equipment' : 'Create missing rooms';
      return m('div.flex.items-center.justify-between.mb3', [
        m('span.f4', label),
        m(ToggleSwitch, {
          id: 'create-missing-toggle',
          checked: checked,
          ariaLabel: label,
          onchange: function () {
            ModalForm.form.createMissing(!checked);
          }
        })
      ]);
    })()
  ])
}

module.exports = ModalForm;
